/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/marketing/eor-whitelabel.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import React from 'react';
import { ArrowRight, BarChart3, CheckCircle, CreditCard, Eye, Globe, Handshake, Layers, Link2, MessageSquare, Settings, Target, TrendingDown, UserCheck, Users, X } from 'lucide-preact';

/*----------------------------------
- APP
----------------------------------*/

import PublicHeader from '@/client/components/marketing/PublicHeader';
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- CONTROLEUR
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/eor-whitelabel', { ...({
  static: {
    refresh: '1h',
    urls: ['/eor-whitelabel']
  }
}), ...{ filepath: "/app/client/pages/marketing/eor-whitelabel.tsx", sourceLocation: { line: 20, column: 1 }, id: "marketing_eor_whitelabel" } }, null, ({}) => {
  const [calendlyOpen, setCalendlyOpen] = React.useState(false);
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <Page withLayout={false}>
            <div className="min-h-screen bg-white">
                <PublicHeader currentPage="eor" />

                <section className="relative pt-32 pb-20 px-6 lg:px-8 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} />
                    </div>

                    <div className="max-w-7xl mx-auto relative z-10">
                        <div className="grid lg:grid-cols-2 gap-12 items-center">
                            <div>
                                <div className="inline-block mb-6">
                                    <span className="bg-orange-500/20 text-orange-300 px-4 py-2 rounded-full text-sm font-semibold border border-orange-500/30">
                                        For EOR & Global Payroll Platforms
                                    </span>
                                </div>

                                <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                                    Your clients need to hire.
                                    <br />
                                    You don't have a recruitment solution.
                                    <br />
                                    Your competitors do.
                                </h1>

                                <p className="text-xl text-slate-300 mb-8 leading-relaxed">
                                    CrossPath plugs directly into your platform and becomes your Talent Acquisition layer — fully integrated, operational in 30 days, covering 42+ countries. You own the relationship. CrossPath delivers.
                                </p>

                                <div className="flex flex-col sm:flex-row gap-4">
                                    <button type="button" onClick={() => setCalendlyOpen(true)} className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl inline-flex items-center justify-center gap-2">
                                        Book a Consultancy Call
                                        <ArrowRight size={20} />
                                    </button>
                                    <button type="button" onClick={() => document.getElementById('how-it-works')?.scrollIntoView({
                  behavior: 'smooth'
                })} className="border-2 border-slate-600 text-white hover:bg-slate-800 px-8 py-4 rounded-lg font-semibold text-lg transition-all inline-flex items-center justify-center gap-2">
                                        See How It Works
                                        <ArrowRight size={20} />
                                    </button>
                                </div>
                            </div>

                            <div className="relative hidden lg:block">
                                <div className="relative w-full h-96">
                                    <div className="absolute inset-0 bg-gradient-to-br from-orange-500/20 to-blue-500/20 rounded-2xl blur-3xl" />
                                    <div className="relative bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 h-full flex flex-col items-center justify-center gap-6">
                                        <div className="flex items-center gap-4 w-full">
                                            <div className="flex-1 bg-slate-700/50 rounded-lg p-4 border border-slate-600">
                                                <div className="text-orange-400 font-bold text-sm mb-2">Your Platform</div>
                                                <div className="space-y-2">
                                                    <div className="h-2 bg-slate-600 rounded w-3/4" />
                                                    <div className="h-2 bg-slate-600 rounded w-1/2" />
                                                </div>
                                            </div>
                                            <div className="flex flex-col items-center gap-2">
                                                <ArrowRight className="w-6 h-6 text-orange-400" />
                                                <div className="text-xs text-orange-400 font-semibold">API</div>
                                                <ArrowRight className="w-6 h-6 text-blue-400 rotate-180" />
                                            </div>
                                            <div className="flex-1 bg-slate-700/50 rounded-lg p-4 border border-slate-600">
                                                <div className="text-blue-400 font-bold text-sm mb-2">CrossPath</div>
                                                <div className="space-y-2">
                                                    <div className="h-2 bg-slate-600 rounded w-2/3" />
                                                    <div className="h-2 bg-slate-600 rounded w-3/4" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="relative w-full">
                                            <div className="absolute inset-0 flex items-center justify-center">
                                                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                                                    <Users className="w-6 h-6 text-white" />
                                                </div>
                                            </div>
                                            {[...Array(8)].map((_, index) => <div key={index} className="absolute w-8 h-8 bg-orange-500/30 rounded-full border border-orange-500/50" style={{
                      left: `${50 + 35 * Math.cos(index * Math.PI * 2 / 8)}%`,
                      top: `${50 + 35 * Math.sin(index * Math.PI * 2 / 8)}%`,
                      transform: 'translate(-50%, -50%)'
                    }}>
                                                    <UserCheck className="w-4 h-4 text-orange-400 m-auto mt-2" />
                                                </div>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-20 px-6 lg:px-8 bg-slate-50">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl font-bold text-slate-900 mb-4">
                                The gap you can't afford to ignore
                            </h2>
                        </div>

                        <div className="grid md:grid-cols-3 gap-8">
                            {[{
              icon: TrendingDown,
              title: 'EOR margins are under pressure',
              text: 'Compliance, payroll, local entities — every EOR offers the same thing. Service models are converging. The race to the bottom has started.'
            }, {
              icon: Users,
              title: 'No hire = no EOR contract',
              text: "Your clients come with a hiring need. If you can't answer it, they find someone who can — and that someone becomes their EOR provider too."
            }, {
              icon: Settings,
              title: "Building it yourself isn't the answer",
              text: "Recruitment isn't a feature you can ship. It's a human, complex, market-specific discipline. It can't be fully automated. It requires expertise, network, and process."
            }].map((item, index) => <div key={item.title} className="bg-white rounded-xl p-8 border-2 border-slate-200 hover:border-orange-300 hover:shadow-lg transition-all">
                                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                                        <item.icon className="w-6 h-6 text-orange-600" />
                                    </div>
                                    <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
                                    <p className="text-slate-600 leading-relaxed">{item.text}</p>
                                </div>)}
                        </div>
                    </div>
                </section>

                <section className="py-20 px-6 lg:px-8 bg-white">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl font-bold text-slate-900 mb-4">
                                CrossPath : Your Talent Layer, Ready to Deploy
                            </h2>
                            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                                A fully integrated recruitment infrastructure — technical and human. Not a partnership. Not a referral. A native layer inside your platform.
                            </p>
                        </div>

                        <div className="grid lg:grid-cols-2 gap-12">
                            <div className="bg-white rounded-2xl p-8 border-2 border-blue-300 shadow-lg relative overflow-hidden">
                                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/5 rounded-full -mr-16 -mt-16" />
                                <div className="relative">
                                    <div className="inline-block bg-blue-500 text-white px-4 py-2 rounded-lg font-semibold mb-6 shadow-md">
                                        The Integration
                                    </div>
                                </div>

                                <div className="space-y-6">
                                    {[{
                  icon: Link2,
                  title: 'Bi-directional API',
                  text: 'Your clients post positions directly from your interface. Candidate data, status updates, and pipeline progress flow back in real time.'
                }, {
                  icon: Eye,
                  title: 'Your clients stay on your platform',
                  text: 'CrossPath operates behind the scenes. Your brand, your interface, your relationship.'
                }, {
                  icon: BarChart3,
                  title: 'Real-time EOR dashboard',
                  text: 'Full visibility on every open position : candidates at each stage, CSM activity, time-to-first-CV.'
                }, {
                  icon: CreditCard,
                  title: 'You control the commercial relationship',
                  text: 'You keep the client relationship. CrossPath operates behind the scenes. Your margin, your model.'
                }].map(item => <div key={item.title} className="flex gap-4">
                                            <div className="flex-shrink-0 w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                                                <item.icon className="w-5 h-5 text-white" />
                                            </div>
                                            <div>
                                                <h4 className="font-bold text-slate-900 mb-1">{item.title}</h4>
                                                <p className="text-slate-700 text-sm leading-relaxed">{item.text}</p>
                                            </div>
                                        </div>)}
                                </div>
                            </div>

                            <div className="bg-gradient-to-br from-orange-50 via-orange-100 to-orange-50 rounded-2xl p-8 border-2 border-orange-300 shadow-xl relative overflow-hidden">
                                <div className="absolute top-0 right-0 w-40 h-40 bg-orange-500/10 rounded-full -mr-20 -mt-20" />
                                <div className="absolute bottom-0 left-0 w-32 h-32 bg-orange-500/10 rounded-full -ml-16 -mb-16" />
                                <div className="relative">
                                    <div className="inline-block bg-gradient-to-r from-orange-500 to-orange-600 text-white px-4 py-2 rounded-lg font-semibold mb-6 shadow-lg">
                                        The Expertise
                                    </div>
                                </div>

                                <div className="space-y-6">
                                    {[{
                  icon: Target,
                  title: 'Position qualification call',
                  text: 'A CrossPath CSM contacts your client to deep-dive into the real role specs. This is what separates targeted recruitment from generic job posting.'
                }, {
                  icon: Globe,
                  title: 'Network distribution',
                  text: 'The position is distributed across a curated network of 10,000+ vetted headhunters across 42+ countries, matched by sector, seniority, market and speed score.'
                }, {
                  icon: CheckCircle,
                  title: 'Double validation before delivery',
                  text: 'Every candidate goes through a recruiter interview + manual CSM review. Nothing reaches your client without human sign-off.'
                }, {
                  icon: MessageSquare,
                  title: 'Structured interview support',
                  text: 'CrossPath provides a structured interview methodology to help your client compare candidates objectively and scientifically.'
                }, {
                  icon: Handshake,
                  title: 'Offer & negotiation support',
                  text: 'CrossPath guides both sides through salary benchmarking, offer structuring, and negotiation to maximize closing rate.'
                }].map(item => <div key={item.title} className="flex gap-4">
                                            <div className="flex-shrink-0 w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                                                <item.icon className="w-5 h-5 text-white" />
                                            </div>
                                            <div>
                                                <h4 className="font-bold text-slate-900 mb-1">{item.title}</h4>
                                                <p className="text-slate-700 text-sm leading-relaxed">{item.text}</p>
                                            </div>
                                        </div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="how-it-works" className="py-20 px-6 lg:px-8 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl font-bold text-white mb-4">
                                How CrossPath fits into your existing flow
                            </h2>
                            <p className="text-xl text-slate-300 max-w-3xl mx-auto">
                                The technical integration happens once. Everything after is seamless — invisible to your client, fully visible to your team.
                            </p>
                        </div>

                        <div className="space-y-12">
                            <div className="relative">
                                <div className="inline-block bg-slate-700 text-slate-300 px-4 py-2 rounded-lg font-semibold mb-4 text-sm">
                                    PHASE 1 — One-time setup
                                </div>
                                <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
                                    <h4 className="text-lg font-bold text-white mb-2">
                                        Technical Integration <span className="text-slate-400 font-normal text-sm">(≤ 30 days)</span>
                                    </h4>
                                    <p className="text-slate-300">
                                        CrossPath connects to your platform via a dedicated API. Custom scoping, dedicated integration manager, full testing before go-live. This happens once.
                                    </p>
                                </div>
                            </div>

                            <div className="relative">
                                <div className="inline-block bg-orange-500 text-white px-4 py-2 rounded-lg font-semibold mb-4 text-sm">
                                    PHASE 2 — Regular client flow
                                </div>
                                <div className="space-y-6">
                                    {[{
                  num: '1',
                  title: 'Client Acquisition',
                  text: 'Your client arrives through your marketing channels or via one of your Account Managers. They interact exclusively with your platform and your brand — CrossPath is never visible at this stage.'
                }, {
                  num: '2',
                  title: 'Position Qualification',
                  subtitle: '(CrossPath takes over)',
                  text: 'Once a hiring need is submitted, a CrossPath CSM contacts the client — from a branded email address matching your domain — to run a structured qualification call. Deep specs, real requirements, beyond the job description. Your client experiences it as part of your service.'
                }, {
                  num: '3',
                  title: 'Sourcing & Selection',
                  text: 'The position is matched to the right headhunters across our 10,000+ network (42+ countries). Every candidate goes through a recruiter interview + manual CSM validation before any submission. Nothing reaches your client without human sign-off.'
                }, {
                  num: '4',
                  title: 'Candidate Delivery',
                  text: 'Your client reviews candidates directly in your interface — CV, recruiter notes, status. One click to validate, reject, or request more information. CrossPath supports structured interviews and offer negotiation through to acceptance.'
                }].map(step => <div key={step.num} className="bg-slate-800 rounded-xl p-6 border-2 border-orange-500/30 hover:border-orange-500 transition-all">
                                            <div className="flex gap-4">
                                                <div className="flex-shrink-0 w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center font-bold text-white">
                                                    {step.num}
                                                </div>
                                                <div className="flex-1">
                                                    <h4 className="text-lg font-bold text-white mb-1">
                                                        {step.title}
                                                        {step.subtitle && <span className="text-orange-400 ml-2 text-sm font-normal">{step.subtitle}</span>}
                                                    </h4>
                                                    <p className="text-slate-300">{step.text}</p>
                                                </div>
                                            </div>
                                        </div>)}
                                </div>
                            </div>

                            <div className="relative">
                                <div className="inline-block bg-green-600 text-white px-4 py-2 rounded-lg font-semibold mb-4 text-sm">
                                    PHASE 3 — EOR takes back control
                                </div>
                                <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
                                    <h4 className="text-lg font-bold text-white mb-2">Contract & Onboarding</h4>
                                    <p className="text-slate-300">
                                        Once the candidate is accepted, your team takes over. Contract signature, EOR onboarding, payroll setup — your core business, fully activated by a hire CrossPath made possible.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <p className="text-center text-slate-400 text-sm italic mt-12">
                            Your client never knows CrossPath is involved. They see your brand, your interface, your team — at every step.
                        </p>
                    </div>
                </section>

                <section className="py-16 px-6 lg:px-8 bg-orange-500">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
                            {[{
              value: '10,000+',
              label: 'Vetted recruiters in the network'
            }, {
              value: '42+',
              label: 'Countries covered'
            }, {
              value: '30 days',
              label: 'To go live'
            }, {
              value: '12 days',
              label: 'Average time to first client interview'
            }, {
              value: '~70%',
              label: 'Average profiles accepted at first client selection step'
            }].map((stat, index) => <div key={stat.label} className="text-center">
                                    <div className="text-4xl font-bold text-white mb-2">{stat.value}</div>
                                    <div className="text-orange-100 text-sm">{stat.label}</div>
                                </div>)}
                        </div>
                    </div>
                </section>

                <section className="py-32 px-6 lg:px-8 bg-gradient-to-br from-slate-800 to-slate-900">
                    <div className="max-w-5xl mx-auto">
                        <div className="bg-slate-700/50 backdrop-blur-sm rounded-2xl p-12 border border-slate-600 shadow-2xl text-center">
                            <div className="inline-block bg-green-600 text-white px-4 py-2 rounded-lg font-semibold mb-6 text-sm">
                                EXISTING PARTNERSHIPS
                            </div>
                            <h2 className="text-4xl font-bold text-white mb-6">
                                Already working with recruitment agencies?
                            </h2>
                            <p className="text-xl text-slate-200 leading-relaxed max-w-3xl mx-auto mb-8">
                                Bring them into your own interface. Unify the experience for your clients, centralize pipeline management, and keep your existing partners — on a single, structured platform.
                            </p>
                            <div className="flex items-center justify-center gap-6 text-slate-300">
                                <div className="flex items-center gap-2">
                                    <CheckCircle className="w-5 h-5 text-green-400" />
                                    <span className="text-sm">Unified interface</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <CheckCircle className="w-5 h-5 text-green-400" />
                                    <span className="text-sm">Centralized tracking</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <CheckCircle className="w-5 h-5 text-green-400" />
                                    <span className="text-sm">Keep existing partners</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-20 px-6 lg:px-8 bg-white">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl font-bold text-slate-900 mb-4">
                                Flexible service models — built around your business
                            </h2>
                        </div>

                        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                            <div className="bg-white rounded-2xl p-8 border-2 border-slate-200 hover:border-blue-300 hover:shadow-lg transition-all relative">
                                <div className="mb-4">
                                    <div className="inline-block bg-slate-100 text-slate-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                                        MOST POPULAR
                                    </div>
                                </div>
                                <h3 className="text-2xl font-bold text-slate-900 mb-4">Success-Based</h3>
                                <p className="text-slate-700 leading-relaxed mb-6">
                                    You activate support around successful hiring outcomes, keeping CrossPath aligned with your client's result.
                                </p>
                                <div className="flex items-center gap-2 text-sm text-slate-600">
                                    <CheckCircle className="w-4 h-4 text-green-500" />
                                    <span>Outcome-aligned</span>
                                </div>
                            </div>

                            <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-8 border-2 border-orange-400 shadow-2xl relative overflow-hidden transform hover:scale-105 transition-all">
                                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16" />
                                <div className="relative">
                                    <div className="mb-4">
                                        <div className="inline-block bg-white text-orange-600 px-3 py-1 rounded-full text-xs font-bold mb-3">
                                            PREMIUM
                                        </div>
                                    </div>
                                    <h3 className="text-2xl font-bold text-white mb-4">RPO Model</h3>
                                    <p className="text-orange-50 leading-relaxed mb-6">
                                        For clients with ongoing or high-volume hiring needs. A dedicated recruitment capacity, fully embedded in your service offering.
                                    </p>
                                    <div className="flex items-center gap-2 text-sm text-orange-100">
                                        <CheckCircle className="w-4 h-4 text-white" />
                                        <span>Dedicated capacity</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className="text-center text-slate-600 mt-8 text-sm">
                            The client relationship stays with you. CrossPath never appears on your client's invoice.
                        </p>
                    </div>
                </section>

                <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-violet-50 to-blue-50">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl font-bold text-slate-900 mb-4">
                                Full commercial visibility — for your entire team
                            </h2>
                            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                                CrossPath doesn't just manage recruitment. It gives your management team a real-time performance layer on top of it.
                            </p>
                        </div>

                        <div className="grid md:grid-cols-3 gap-8">
                            {[{
              icon: Layers,
              title: 'Designed for teams',
              text: 'Your platform access is structured around roles — Admin, Manager, and Account Manager. Each user sees exactly what they need, nothing more.'
            }, {
              icon: Link2,
              title: 'Track every lead source',
              text: 'Every client mandate is linked to the Account Manager who originated it. Your management team sees in real time who is generating business — and how those mandates perform.'
            }, {
              icon: BarChart3,
              title: 'Team performance, at a glance',
              text: 'Conversion rates, time-to-hire, candidate acceptance rates — broken down by Account Manager, by market, by period. The data your leadership team needs to make decisions.'
            }].map((item, index) => <div key={item.title} className="bg-white rounded-xl p-8 border-2 border-slate-200 hover:border-violet-300 hover:shadow-lg transition-all">
                                    <div className="w-12 h-12 bg-violet-100 rounded-lg flex items-center justify-center mb-4">
                                        <item.icon className="w-6 h-6 text-violet-600" />
                                    </div>
                                    <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
                                    <p className="text-slate-600 leading-relaxed">{item.text}</p>
                                </div>)}
                        </div>

                        <p className="text-center text-slate-600 mt-8 text-sm">
                            Visibility flows upward. Account Managers see their own pipeline. Managers see their team. Admins see everything.
                        </p>
                    </div>
                </section>

                <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
                    <div className="max-w-4xl mx-auto text-center">
                        <div>
                            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 whitespace-nowrap">
                                Don't let your clients hire somewhere else.
                            </h2>
                            <p className="text-xl text-slate-300 mb-8">
                                Custom integration. Live in 30 days. Zero recruitment infrastructure to build on your side.
                            </p>

                            <button type="button" onClick={() => setCalendlyOpen(true)} className="bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl inline-flex items-center justify-center gap-2">
                                Book a Consultancy Call
                                <ArrowRight size={20} />
                            </button>

                            <p className="text-slate-400 text-sm mt-4">
                                30 minutes. No commitment. We scope your integration together.
                            </p>
                        </div>
                    </div>
                </section>

                <footer className="bg-slate-900 py-12 px-6 lg:px-8 border-t border-slate-800">
                    <div className="max-w-7xl mx-auto text-center">
                        <p className="text-slate-400">
                            © 2026 CrossPath. All rights reserved.
                        </p>
                    </div>
                </footer>

                {calendlyOpen && <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-xl w-full max-w-2xl h-[875px] relative">
                            <button type="button" onClick={() => setCalendlyOpen(false)} className="absolute top-4 right-4 text-slate-500 hover:text-black text-xl z-10 w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-lg">
                                <X size={20} />
                            </button>
                            <iframe src="https://calendly.com/emmanuel_beauvais/crosspath" width="100%" height="100%" frameBorder="0" className="rounded-xl" />
                        </div>
                    </div>}
            </div>
        </Page>;
});
};
